import { ADMIN_DATA, SET_USER_RESTAURANTS } from './types';


export const fetchAdminRestaurant = (data) => {
  return {
    type: ADMIN_DATA,
    data
  }
};

export const setUserRestaurants = (payload) => {
  return {
    type: SET_USER_RESTAURANTS,
    payload,
  }
};


